import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connectLean } from 'lean-redux';
import { Link, withRouter } from 'react-router';
import AssignItem from 'legacy/src/components/assessment/AssignItem';
import { Icon } from 'legacy-packages/ft-cb';
import { UNITS as COPY } from 'chameleon/ui-stack/utilities/copy';

/**
 * Draws unit sharing
 * */
class Assign extends PureComponent {
  static displayName = 'Assign';

  static propTypes = {
    disabled: PropTypes.bool,
    isAssigned: PropTypes.bool,
    isUnlocked: PropTypes.bool,
    url: PropTypes.string,
    buttonIcon: PropTypes.any,
    showLabel: PropTypes.bool,
    onItemAction: PropTypes.func,
    canAssignRedirect: PropTypes.bool,
  };

  static defaultProps = {
    buttonIcon: null,
    showLabel: true,
    isUnlocked: false,
    onItemAction: () => {},
    canAssignRedirect: true,
  };

  constructor(props) {
    super(props);

    this.onAssignItem = this.onAssignItem.bind(this);
  }

  /**
   * On assign callback
   * */
  onAssignItem(assignmentsResponse) {
    const { saveAssignedState, onItemAction } = this.props;
    assignmentsResponse.forEach(({ id, status }) => {
      saveAssignedState(id, status);
    });
    onItemAction && onItemAction();
  }

  render() {
    const {
      url,
      items,
      disabled,
      item: { assessmentId, displayName },
      isAssigned,
      assignments,
      unitNumber,
      unitTitle,
      userData: { isAdmin, isCoordinator },
      buttonIcon,
      showLabel,
      isUnlocked,
      isPreApSubject,
      isPPCAssign,
      buttonClassName,
      ariaLabel,
      canAssignRedirect,
    } = this.props;

    let label = isAssigned ? 'Assigned' : 'Unassigned';
    const iconClassName = !disabled ? 'active' : 'inactive';
    const labelClassName = isAssigned ? 'active' : 'inactive';

    let icon = buttonIcon || (
      <Icon
        width={20}
        height={19}
        name="share-assign"
        className={`user-share-icon ${iconClassName}`}
      />
    );

    const assignmentStatus = assignments.get(assessmentId);
    if (isAssigned && assignmentStatus === 'opened' && !isUnlocked) {
      icon = (
        <Icon
          className="resource-icon-withstatus"
          name="unlocked"
          width="16"
          height="16"
        />
      );
    }

    /**
     * We want to show the assign button for PPC action on resource search results page, to do this
     * icon needs to be a falsy
     */
    if (isPPCAssign) {
      icon = null;
    }

    const isAdminOrCoordinator = isAdmin || isCoordinator;

    let notificationText;
    if (isAdminOrCoordinator) {
      notificationText = COPY.ADMIN_COORDINATOR.ASSIGN_NOTIFICATION;
      // PreAP show Assigned label
      // https://academicmerit.atlassian.net/browse/FY-9063
      label = 'Assigned';
    }

    const assignModalTitle = COPY.ASSIGN.MODAL_TITLE(
      unitNumber,
      displayName,
      isPreApSubject,
      unitTitle,
    );

    return (
      <div className="item-actions">
        {showLabel && <label className={labelClassName}>{label}</label>}
        {assessmentId ? (
          <AssignItem
            onAssignRedirect={canAssignRedirect}
            disabled={disabled}
            isAdminOrCoordinator={isAdminOrCoordinator}
            groups={items}
            itemId={Number(assessmentId)}
            itemTitle={assignModalTitle}
            button={icon}
            onAssign={this.onAssignItem}
            forcePopupClose
            notificationText={notificationText}
            buttonClassName={buttonClassName}
            ariaLabel={ariaLabel}
          />
        ) : (
          <Link disabled={disabled} to={`${url}&forceAssign=true`}>
            {icon}
          </Link>
        )}
      </div>
    );
  }
}

export default connectLean({
  getInitialState() {
    return {
      isAssigned: false,
      assignments: new Map(),
    };
  },
  mapState(state) {
    const { isAssigned, assignments } = state;
    return {
      assignments,
      isAssigned,
    };
  },
  saveAssignedState(assessmentId, status) {
    let { assignments } = this.state;
    assignments.set(assessmentId, status);
    this.setState({
      assignments: new Map(assignments),
      isAssigned: true,
    });
  },
})(withRouter(Assign));
